
import {Component, Vue, Prop, Watch} from 'vue-property-decorator';

@Component
export default class ReportUploadModal extends Vue {
    @Prop({required: true}) item!: any;  // Родительский элемент
    selectedFiles: File[] = [];
    searchQuery: string = '';

    @Watch('item', {immediate: true, deep: true})
    onItemChange(newItem: any) {
        this.selectedFiles = [];

        if (newItem?.input_report) {
            const fakeFile = new File([""], newItem.input_report);  // нерабочий файл, но отображается
            this.selectedFiles = [fakeFile];
        }
    }

    fileSize = 0

    async mounted() {
        if (this.item && this.item.input_report && this.item.input_report.files) {
            this.selectedFiles = this.item.input_report.files || [];
        }
        this.fileSize = await this.getFileSize();
    }

    close_report_modal() {
        this.$root.$emit("bv::hide::modal", "add_input_report_modal");
    }

    handleFileChange(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files) {
            this.selectedFiles = Array.from(input.files);
            input.value = '';  // сбросить, чтобы можно было повторно выбрать тот же файл
        }
    }


    handleFileDrop(event: DragEvent) {
        event.preventDefault();
        const files = event.dataTransfer?.files;
        if (files) {
            this.selectedFiles.push(...Array.from(files));
        }
    }

    triggerFileInput() {
        const fileInput = this.$refs.fileInput as HTMLInputElement | undefined;
        if (fileInput) {
            fileInput.click();
        }
    }

    removeFile(index: number) {
        const fileToRemove = this.filteredFiles[index];
        const originalIndex = this.selectedFiles.indexOf(fileToRemove);
        if (originalIndex !== -1) {
            this.selectedFiles.splice(originalIndex, 1);
        }
        const filename = this.selectedFiles.length ? this.selectedFiles[0].name : '';
        this.$emit('addReport', filename);
    }

     async getFileSize() {
        if (!this.item?.id) return 0;  // защита
        try {
            const response = await fetch(`/api-py/psd/get-file-size/${this.item.id}`);
            if (response.status === 200) {
                return await response.json();
            }
        } catch (error) {
            console.error("Ошибка загрузки размера файла:", error);
        }
        return 0;
    }


    async uploadFiles() {
        if (this.selectedFiles.length > 0) {
            try {
                const formData = new FormData();
                formData.append('report_number', this.item.report_number);
                for (const file of this.selectedFiles) {
                    formData.append('files', file);
                }

                const response = await fetch('/api-py/psd/upload-input-report', {
                    method: 'POST',
                    body: formData
                });

                if (!response.ok) {
                    throw new Error('Ошибка при загрузке файла');
                }

                const result = await response.json();
                console.log('Файл успешно загружен:', result);
                console.log

                this.$root.$emit("bv::hide::modal", "add_input_report_modal");
                this.$emit("addReport", result.filenames[0]);  // берем только имя файла, как string
            } catch (error) {
                console.error('Ошибка загрузки файлов:', error);
            }
        }
    }

    get filteredFiles() {
        return this.selectedFiles.filter(file =>
            file.name.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
    }
}
